import { render, staticRenderFns } from "./SetGroupModal.vue?vue&type=template&id=14a91116&scoped=true"
import script from "./SetGroupModal.vue?vue&type=script&lang=ts"
export * from "./SetGroupModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a91116",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14a91116')) {
      api.createRecord('14a91116', component.options)
    } else {
      api.reload('14a91116', component.options)
    }
    module.hot.accept("./SetGroupModal.vue?vue&type=template&id=14a91116&scoped=true", function () {
      api.rerender('14a91116', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/SetGroupModal.vue"
export default component.exports